import axios from "axios";
import { STORAGE } from "../constants";
import { StorageService } from "./storage";

const _HTTP_ = axios.create();

_HTTP_.interceptors.request.use((config) => {
  const token = StorageService.get(STORAGE.TOKEN);
  if (token) {
    config.headers["x-token"] = token;
  }
  return config;
});

_HTTP_.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.log(error)
    if (error.response && error.response.data) {
      const { statusCode, message } = error.response.data;
      if (error.response.status === 401) {
        handleUnauthorized();
        return Promise.reject(message || error.response.data.error);
      }

      return handleResponseCode(
        statusCode || 400,
        message || error.response.data.error
      );
    }

    return Promise.reject(error);
  }
);

const handleUnauthorized = () => {
  window.location.replace("/auth/login");
};

const handleResponseCode = (code: number, errorMessage: any) => {
  switch (code) {
    case 401:
      StorageService.clear();
      window.location.replace('/auth/login');
      break;
    default:
      return Promise.reject(errorMessage || { message: "Error desconocido." });
  }
};

export const HTTP = _HTTP_;
